module.exports = __webpack_public_path__ + "img/ziyuanbg.cb4fbb1e.png";